import React from 'react';
import { Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import FormattedHTMLMessage from '@/components/FormattedHTMLMessage';
import { hasMinimumLength, removeEmpty, truncateText } from '@/utils/resultsHelper';
import { isSplitUrl, joinUrl } from '@/constants/urls';
import FormObjectsFormButtons from './FormObjectsFormButtons';

const FormObjectInformationHeaderContainer = ({
  allowAdd,
  allowRemove,
  canEdit,
  children,
  deleteItem,
  entity,
  field,
  insertItem,
  items,
  textField,
}) => {
  const validItems = removeEmpty(items);
  const text = validItems.length === 1 ? validItems[0][textField] : null;
  const checkUrl = isSplitUrl(text) ? joinUrl(text) : text;
  const hasText = hasMinimumLength(checkUrl);

  if (!canEdit && validItems.length === 1) {
    return null;
  }

  return (
    <Header as="h4" className="aridhia-form-object-information-header font-weight-dark">
      {hasText && (
      <FormattedHTMLMessage id={`${entity}.showing.one.header`} values={{ text: truncateText(checkUrl, 60) }} />
      )}
      {validItems.length === 1 && !hasText && (<FormattedHTMLMessage id={`${entity}.unspecified.header`} />)}
      {validItems.length > 1 && (
      <>
        <FormattedMessage id={`${entity}.showing.header`} />
        {children}
      </>
      )}
      {canEdit && (
      <div className="float-r">
        <FormObjectsFormButtons
          allowAdd={allowAdd}
          allowRemove={allowRemove}
          deleteItem={deleteItem}
          entity={entity}
          field={field}
          insertItem={insertItem}
        />
      </div>
      )}
    </Header>
  );
};

export default FormObjectInformationHeaderContainer;
